import React from 'react';
import Stack from '../Stack';
import { getSpacing } from '../../../utils/spacing';
import Text from '../Text';
import { Switch as RNSwitch } from 'react-native';
import { colors } from '../../../utils/theme';
import { useIsDisabledByParent } from '../IsDisabledProvider';

export type SwitchOwnProps = {
    value: boolean;
    onChange: (value: boolean) => void;
    error?: string;
    isDisabled?: boolean;
    title: string;
    testID?: string;
};

export type SwitchProps = SwitchOwnProps;

const Switch: React.FC<SwitchProps> = (props) => {
    const disabledByParent = useIsDisabledByParent(props.isDisabled);
    return (
        <Stack horizontal space={getSpacing(2.5)} align="center" justify="flex-start">
            <Text variant="body-1">{props.title}</Text>
            <RNSwitch
                value={props.value}
                onValueChange={() => {
                    props.onChange(!props.value);
                }}
                disabled={disabledByParent}
                testID={props.testID}
                thumbColor={props.value ? colors.Success : colors.Alert}
                trackColor={{ false: colors['Grey-Light'], true: colors['Grey-Light'] }}
            />
        </Stack>
    );
};

export default React.memo(Switch);
